import { Navbar, Text, useNavbarLayout } from '@workwhile/web-ui'
import { Box, Flex, Tooltip } from 'ui'
import { useAuthContext } from 'components/auth'

const LOGO_SIZE = '32px'

export const CompanyHeader = () => {
  const { company } = useAuthContext()
  const isClosed = useNavbarLayout() === 'closed'

  if (!company) {
    return null
  }

  const logo = company.logoUrl ? (
    <img
      src={company.logoUrl}
      alt={company.name}
      width={'100%'}
      height={'100%'}
      style={{ objectFit: 'contain' }}
    />
  ) : (
    <Flex
      width={'100%'}
      height={'100%'}
      backgroundColor={'neutrals.200'}
      borderRadius={'50%'}
    />
  )
  const missingLogoTooltip = company.logoUrl
    ? null
    : 'Please contact us to upload your company logo'
  const logoTooltip = isClosed ? company.name : missingLogoTooltip

  return (
    <Navbar.Company>
      <Box flexShrink={0} width={LOGO_SIZE} height={LOGO_SIZE}>
        {logoTooltip ? <Tooltip content={logoTooltip}>{logo}</Tooltip> : logo}
      </Box>
      {isClosed ? null : (
        <Text weight="medium" lineClamp={2}>
          {company.name}
        </Text>
      )}
    </Navbar.Company>
  )
}
